const SDK_VERSION = '8.30.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
